import { format, add } from 'date-fns'
import type { Duration } from 'date-fns'

const COUNTRY = 'it-IT'

export default {
  methods: {
    formatDate (dateString: string, options: Intl.DateTimeFormatOptions = { dateStyle: 'medium' }, lang = COUNTRY) {
      if (dateString !== '' && dateString != null && dateString !== undefined) {
        const date = new Date(dateString)
        return new Intl.DateTimeFormat(lang, options).format(date)
      }
    },
    formatDateAndTime (dateString: string, hideSeconds?: boolean) {
      if (dateString) {
        const date = new Date(dateString)
        return new Intl.DateTimeFormat(COUNTRY, {
          dateStyle: 'short',
          timeStyle: hideSeconds ? 'short' : 'medium'
        }).format(date)
      }
    },
    formatCurrency (currency: number) {
      return new Intl.NumberFormat(COUNTRY, { style: 'currency', currency: 'EUR' }).format(currency)
    },
    formatPercentage (percentage: number) {
      return new Intl.NumberFormat(COUNTRY, { style: 'percent', maximumFractionDigits: 1 }).format(percentage / 100)
    },
    minusValue (value: number) {
      return value > 0 ? -value : value
    },

    formateDateWithoutLocale (date: string) {
      if (date && typeof date === 'string') {
        const structuredDate = new Date(date)
        if (structuredDate) {
          return `${('0' + structuredDate.getDate()).slice(-2)}.${('0' + (structuredDate?.getMonth() + 1))?.slice(
            -2
          )}.${structuredDate.getFullYear()}`
        }
      }
      return ''
    },

    formateDateAndTimeWithoutLocale (date: string) {
      if (date && typeof date === 'string') {
        const structuredDate = new Date(date)
        if (structuredDate) {
          return `${('0' + structuredDate.getDate()).slice(-2)}.${('0' + (structuredDate?.getMonth() + 1))?.slice(
            -2
          )}.${structuredDate.getFullYear()} ${('0' + structuredDate.getHours()).slice(-2)}:${(
            '0' + structuredDate.getMinutes()
          ).slice(-2)}`
        }
      }
      return ''
    },

    formateDateAndTimeWithLocale (date: string) {
      if (date && typeof date === 'string') {
        const match = date.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/)
        if (match) {
          const [, year, month, day, hour, minute] = match
          return `${day}.${month}.${year} ${hour}:${minute}`
        }
      }
      return ''
    },

    getFormattedNextDate (date: string, dateFormat: string, duration: Duration) {
      let formattedNextDate = ''
      if (date) {
        const lastDate = new Date(date)
        const nextDate = add(lastDate, duration)
        formattedNextDate = format(nextDate, dateFormat)
      }
      return formattedNextDate
    },

    formatDateStr (date: string, splitter: string, separator: string) {
      let formattedDate = ''
      if (date && splitter) {
        const dt = date.split(splitter)
        separator = separator !== null ? separator : '.'
        formattedDate = dt[0] + separator + dt[1] + separator + dt[2]
      }
      return formattedDate
    }
  }
}
